import React from "react";
import {
  Create,
  SimpleForm,
  TextInput,
  DateInput,
  NumberInput,
  BooleanInput,
  required,
  ReferenceInput,
  SelectInput,
  AutocompleteInput,
 FormDataConsumer,
} from "react-admin";

import { useStyles } from "../../formStyles";
import { CreateToolbar} from "../../CreateToolbar";
import {AgentInput} from "./component/AgentInput"
import ExpiringInsurerInput from './component/ExpiringInsurerInput';
import ExpiringBrokerInput from './component/ExpiringBrokerInput';
import PolicyExpiryDateInput from "./component/PolicyExpiryDateInput";
import FinilisedPremiumInput from './component/FinilisedPremiumInput';
import CurrentInsurerInput from './component/CurrentInsurerInput';
import QuoteReleaseDateInput from './component/QuoteReleaseDateInput';

export const RfqRegisterCreate = (props) => {

  const classes = useStyles({});

  const defaultValues = {
    isActive: true,
    revisionCount: 0,
  };

  const requiredExceptBusinessTypeOne = (value, allValues) => {
  if (Number(allValues?.bzTypeId) === 1) {
    return undefined;
  }
    return value ? undefined : 'Required';
 };

  return (
    <Create title="RFQ Register Create" {...props} undoable={false}>
      <SimpleForm
        variant="outlined"
        redirect="list"
        toolbar={<CreateToolbar {...props} />}
        initialValues={defaultValues}
      >

        <TextInput
          source="rfqNo"
          label="RFQ No"
          disabled
          fullWidth
          formClassName={classes.one_three_input}
        />

        <DateInput
          source="receivedDate"
          label="Received Date"
          validate={[required()]}
          fullWidth
          formClassName={classes.two_three_input}
        />

        <DateInput
          source="floatDate"
          label="Float Date"
          validate={[required()]}
          fullWidth
          formClassName={classes.last_three_input}
        />

        <ReferenceInput
          label="Agent Type"
          source="agentTypeId"
          reference="lookups"
          filter={{ type: 'RFQAT' }}
          sort={{ field: 'name', order: 'ASC' }}
          fullWidth
          formClassName={classes.one_three_input}
        >
          <SelectInput optionText="name" />
        </ReferenceInput>

        <AgentInput
          source="agent"
          label="Agent"
          fullWidth
          formClassName={classes.two_three_input}
        />

         <TextInput
          source="customer"
          label="Customer"
          fullWidth
          formClassName={classes.last_three_input}
        />

        <TextInput
          multiline
          source="occupancy"
          label="Occupancy"
          fullWidth
        />

        <ReferenceInput
          label="Business Line Type"
          source="ebTypeId"
          validate={[required()]}
          reference="lookups"
          filter={{ type: 'RFQEB' }}
          sort={{ field: 'name', order: 'ASC' }}
          fullWidth
          formClassName={classes.one_three_input}
        >
          <AutocompleteInput optionText="name" />
        </ReferenceInput>

        <ReferenceInput
          label="Policy Type"
          source="policyTypeId"
          validate={[required()]}
           perPage={1000}
          reference="policy-departments"
          sort={{ field: 'name', order: 'ASC' }}
          fullWidth
          formClassName={classes.two_three_input}
        >
          <AutocompleteInput optionText="name" />
        </ReferenceInput>

        <ReferenceInput
          label="RM"
          source="rmid"
          validate={[required()]}
          reference="employees"
          filter={{ typeId: 98 }}
           perPage={1000}
          enableGetChoices={({ q }) => q && q.length >= 2}
          fullWidth
          sort={{ field: 'name', order: 'ASC' }}
          formClassName={classes.last_three_input}>
          <AutocompleteInput
            optionText="name"
            debounce={1000}
            filterToQuery={q => ({ q })}/>
        </ReferenceInput>

        <ReferenceInput
          label="Business Type"
          source="bzTypeId"
          validate={[required()]}
          reference="biz-types"
           perPage={1000}
          sort={{ field: 'name', order: 'ASC' }}
          fullWidth
          formClassName={classes.one_three_input}
        >
          <AutocompleteInput optionText="name" />
        </ReferenceInput>

        <DateInput
          source="inceptionDate"
          label="Inception Date"
          fullWidth
          formClassName={classes.two_three_input}
        />

        <PolicyExpiryDateInput
          formClassName={classes.last_three_input}
        />

        <NumberInput
          source="sumInsured"
          label="Sum Insured"
          fullWidth
          formClassName={classes.one_three_input}
        />

        <NumberInput
          source="netPremium"
          label="Expiring Premium"
          fullWidth
          formClassName={classes.two_three_input}
        />

       <QuoteReleaseDateInput formClassName={classes.last_three_input} />

        <ReferenceInput
          label="Status"
          source="statusId"
          validate={[required()]}
          reference="lookups"
          filter={{ type: 'RFQST' }}
          sort={{ field: 'name', order: 'ASC' }}
           perPage={1000}
          fullWidth
          formClassName={classes.one_three_input}
        >
          <SelectInput optionText="name" />
        </ReferenceInput>

          <ExpiringInsurerInput
            formClassName={classes.two_three_input}
            fullWidth
          />

          <ExpiringBrokerInput
            formClassName={classes.last_three_input}
            fullWidth
          />

        <DateInput
          source="latestQueryRaisedDate"
          label="Latest Query Raised Date"
          fullWidth
          formClassName={classes.one_three_input}
        />

        <FinilisedPremiumInput
            formClassName={classes.two_three_input}
            fullWidth
          />

        <NumberInput
          source="revisionCount"
          label="Revision Count"
          fullWidth
          formClassName={classes.last_three_input}
        />

        <TextInput
          multiline
          source="additionalRemarks"
          label="Additional Remarks"
          fullWidth
        />

       <CurrentInsurerInput
            formClassName={classes.one_three_input}
            fullWidth
          />

        <BooleanInput
              formClassName={classes.two_three_input}
              source="isActive"
              label="Is Active"
            />

      </SimpleForm>
    </Create>
  );
};